function parseMoney(money: string) {
  return parseFloat(money?.replace("$", "").replace(/,/g, ""));
}

export default parseMoney;
